module.exports = __webpack_public_path__ + "static/media/minhdo-portrait.e9e4447f.jpg";